export default class ParallaxHero {

    constructor(options = {}) {
        this.options = options;

        this.$wrapper = options.wrapper;
        this.$background = options.background;
        this.$body = options.body;
        this.$header = options.header;

        this.scrollPos = 0;

        // No support for IE!
        if(window.isInternetExplorer) return;

        this.addEventListeners();
        this.updateDimensions();
    }

    addEventListeners() {
        // update static width/height for wrapper on resize
        window.addEventListener('resize', event => {
            this.updateDimensions();
        });

        // The following tries to prevent unecessary calls to
        // the function that updates the background and text
        // opacity to an absolute minimum. This way, scroll
        // events and the actual calculations are decoupled
        // as much as possible in order to imrpove scrolling
        // and rendering performance.
        let ticking = false;

        const update = () => {
            ticking = false;
            this.updateOpacity();
        };

        const requestTick = () => {
            // By default, repeated calls to functions will be
            // stacked by the browser for execution. By checking
            // if the previous calculations have completed, we
            // prevent the stack from being polluted with unecessary
            // `requestAnimatinoFrame` calls.
            if(ticking) return;
            ticking = true;
            requestAnimationFrame(update);
        };

        window.addEventListener('scroll', event => {
            this.scrollPos = window.scrollY;
            requestTick();
        });
    }

    updateDimensions() {
        let reset = {
            position: 'static',
            width: 'auto',
            height: 'auto',
        };

        for(let prop in reset) {
            this.$wrapper.style[prop] = reset[prop];
        }

        let wrapperRect = this.$wrapper.getBoundingClientRect();
        document.body.style.paddingTop = `${ wrapperRect.height }px`;

        let styles = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: `${ wrapperRect.width }px`,
            height: `${ wrapperRect.height }px`,
        };

        for(let prop in styles) {
            this.$wrapper.style[prop] = styles[prop];
        }
    }

    updateOpacity() {
        const time = this.calcTime();
        const opacity = this.calcOpacity(time);

        // this.$background.style.opacity = opacity.main;
        this.$body.style.opacity = opacity.main;
        this.$header.style.opacity = opacity.header;
        if(opacity.header <= 0) {
            this.$header.style.display = 'none';
        } else {
            this.$header.style.display = 'block';
        }
    }

    calcTime() {
        const wrapperRect = this.$wrapper.getBoundingClientRect();
        const scrollPos   = window.scrollY;
        const startPos    = 0;
        const endPos      = wrapperRect.height;

        const time = (scrollPos - startPos) / (endPos - startPos);
        return Math.min(1, Math.max(0, time));
    }

    calcOpacity(time) {
        let opacity = Math.max(0, 1 - 1.5 * time).toFixed(2);

        return {
            main: opacity,
            header: opacity + 1 - .75 * time,
        };
    }    
}